import gql from "graphql-tag";

export const VALIDATE_ORDER_NUMBER_QUERY = gql`
  query validateOrderNumber($orderNumber: String!) {
    valid: validateOrderNumber(orderNumber: $orderNumber)
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/order/validateOrderNumber.ts